import { ApiBase } from "./ApiBase";
import { config } from "@/lib/config";

class UserApi extends ApiBase {
  setUserRole(role: "Renter" | "Landlord" | "Manager"): Promise<void> {
    return this.put<{ role: string }, void>(
      `${config.VITE_IDENTITY_API_URL}/api/identity/user-role`,
      { role },
    );
  }
}

export const userApi = new UserApi();
